import React from 'react';
import styled from 'styled-components';

const SVG = styled.svg.attrs((props) => ({
  color: props.color || '#222',
}))`
  path {
    fill: ${(props) => props.color};
  }
`;

const Check = ({ width, color }) => {
  return (
    <SVG width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.99984 0.666992C4.39984 0.666992 0.666504 4.40033 0.666504 9.00033C0.666504 13.6003 4.39984 17.3337 8.99984 17.3337C13.5998 17.3337 17.3332 13.6003 17.3332 9.00033C17.3332 4.40033 13.5998 0.666992 8.99984 0.666992ZM8.99984 15.667C5.32484 15.667 2.33317 12.6753 2.33317 9.00033C2.33317 5.32533 5.32484 2.33366 8.99984 2.33366C12.6748 2.33366 15.6665 5.32533 15.6665 9.00033C15.6665 12.6753 12.6748 15.667 8.99984 15.667ZM12.8248 5.31699L7.33317 10.8087L5.17484 8.65866L3.99984 9.83366L7.33317 13.167L13.9998 6.50033L12.8248 5.31699Z"
        fill="#201F2C"
      />
    </SVG>
  );
};

export default Check;
